import { fetchToken } from "../../common/FetchCookie";
import { BASE_URL, CANDIDATE, CANDIDATE_SEARCH_HISTORY } from "../../common/URLs";

const API_BASE_URL = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_SEARCH_HISTORY}`; 

export const fetchCandidateJobHistory = async (token) => {
    const url = `${API_BASE_URL}`; // Proxy path
    try {
      const token = await fetchToken()
      const response = await fetch(url, {
        method: "GET",
        headers: {
          'Accept': "application/json",
          'Authorization':
            `Bearer ${token}`,
        },
      });
    //   console.log("response", response)
      const data = await response.json();
      return data;
    }catch(error){
        console.log("error", error)
    }
  };


// export const addCity = async (newCity) => {
//   const url = `${API_BASE_URL}/core-job-city`; // Proxy path
//   try {
//     const response = await fetch(url, {
//       method: "POST",
//       headers: {
//         Accept: "application/json",
//         "Content-type": "application/json",
//         Authorization: `${AUTH}`,
//       },
//       body: JSON.stringify(newCity),
//     });
//     const data = await response.json();
//     // console.log("API Data", data);
//     return data;
//   } catch (error) {
//     console.log("error", error);
//     throw error;
//   }
// };

// export const deleteCity = async (id) => {
//   try {
//     const response = await fetch(`${API_BASE_URL}/core-job-city/${id}`, {
//       method: "DELETE",
//       headers: {
//         Accept: "application/json",
//         Authorization: `${AUTH}`,
//       },
//     });

//     if (!response.ok) {
//       throw new Error("Error deleting : " + response.statusText);
//     }

//     return await response.json();
//   } catch (error) {
//     throw new Error("Error deleting : " + error.message);
//   }
// };

// export const updateCity = async (id, cityData) => {
//   try {
//     const response = await fetch(`${API_BASE_URL}/core-job-city/${id}`, {
//       method: "PUT",
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json",
//         Authorization: `${AUTH}`,
//       },
//       body: JSON.stringify(cityData),
//     });

//     if (!response.ok) {
//       throw new Error("Error updating : " + response.statusText);
//     }

//     return await response.json();
//   } catch (error) {
//     throw new Error("Error updating : " + error.message);
//   }
// };
